import { Button } from '@kcftech/design-system';
import { useMutation } from '@tanstack/react-query';
import { ConfirmModal } from 'components/modal/ConfirmModal';
import { NoValue } from 'components/no_value/NoValue';
import { useNotificationContext } from 'contexts/NotificationContext';
import { usePermissions } from 'contexts/PermissionsContext';
import { sdClient } from 'contexts/SDKClientContext';
import { LocationsTableCellProps } from 'pages/Settings/Locations/LocationsTable';
import { useState } from 'react';

export function LocationApiKeyCell({ rowData, onChange }: LocationsTableCellProps) {
    const [confirming, setConfirming] = useState(false);
    const { canEditLocationDetails } = usePermissions();
    const { showToast } = useNotificationContext();
    const { mutate: resetApiKey, isPending } = useMutation({
        mutationFn: () => sdClient.generateLocationApiKey({ id: rowData.Id }),

        onSuccess: () => {
            onChange();
            setConfirming(false);
        },

        onError: () =>
            showToast({
                type: 'error',
                content: 'Failed to reset location API key.',
            }),
    });

    return (
        <div className="flex-row align-baseline">
            {rowData.ApiKey ?? <NoValue />}
            {canEditLocationDetails && (
                <Button
                    className="ml-10"
                    appearance="secondary"
                    spacing="compact"
                    disabled={isPending}
                    onClick={() => setConfirming(true)}
                >
                    Reset API Key
                </Button>
            )}
            {confirming && (
                <ConfirmModal
                    actionButtonText="Reset"
                    actionable={!isPending}
                    title="Reset API Key"
                    onAction={resetApiKey}
                    onClose={() => setConfirming(false)}
                    actionText="reset this API key? Resetting this key will disconnect all public API dependent services including OPC."
                    checkText="reset this API key."
                />
            )}
        </div>
    );
}
